export const config = {
  appId: "66701f67-7cce-449e-905a-a9da340032b4",
  redirectUri: "http://localhost:3000",
  scopes: [
    // "files.readwrite.all",
    "user.read", 
    // "files.readwrite",
    // "offline_access",
    // "basic.all",
    // "mail.send",

    // 'calendars.read',
    // "files.read.all",
    // "files.write.all",
    // 'people.read'
    // "Group.ReadWrite.All"
  ],
};
